import React, { Component } from "react";
import { Polar } from "react-chartjs-2";

class PolarChart extends Component {
  render() {
    const data = {
      datasets: [
        {
          data: [11, 16, 7, 18],
          backgroundColor: ["#ff6361", "#20DBCD", "#EF8953", "#50a5f1"],
          label: "My dataset", // for legend
          hoverBorderColor: "#fff",
        },
      ],
      labels: ["Series 1", "Series 2", "Series 3", "Series 4"],
    };

    return (
      <React.Fragment>
        <Polar width={474} height={300} data={data} />
      </React.Fragment>
    );
  }
}

export default PolarChart;
